import { NavLink, Route, Routes } from 'react-router-dom';
import DashboardPage from './components/DashboardPage';
import InventoryPage from './components/InventoryPage';
import SuppliersPage from './components/SuppliersPage';
import PurchaseOrdersPage from './components/PurchaseOrdersPage';
import GreenLotsPage from './components/GreenLotsPage';
import PostRoastBlendsPage from './components/PostRoastBlendsPage';
import RoastBatchesPage from './components/RoastBatchesPage';
import SalesOrdersPage from './components/SalesOrdersPage';
import SettingsPage from './components/SettingsPage';

const App = () => {
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div>
          <h1>Pure Grounds Coffee Co.</h1>
          <p style={{ color: '#94a3b8', margin: '4px 0 0' }}>Inventory Management System</p>
        </div>
        <nav className="nav-links">
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/suppliers">Suppliers</NavLink>
          <NavLink to="/purchase-orders">Purchase Orders</NavLink>
          <NavLink to="/green-lots">Green Coffee</NavLink>
          <NavLink to="/roast-batches">Roast Batches</NavLink>
          <NavLink to="/post-roast-blends">Post-Roast Blends</NavLink>
          <NavLink to="/inventory">Inventory</NavLink>
          <NavLink to="/sales-orders">Sales Orders</NavLink>
          <NavLink to="/settings">Settings</NavLink>
        </nav>
      </aside>
      <main className="content">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/suppliers" element={<SuppliersPage />} />
          <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
          <Route path="/green-lots" element={<GreenLotsPage />} />
          <Route path="/roast-batches" element={<RoastBatchesPage />} />
          <Route path="/post-roast-blends" element={<PostRoastBlendsPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/sales-orders" element={<SalesOrdersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
